<template>
  <div id="app">
    <transition name="slide-fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<style>
/* Estilo para o "carregando..." */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  font-size: 24px;
  color: white;
}

/* Transição de Slide */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(100%); /* Faz o slide para a direita */
  opacity: 0;
}
.slide-fade-enter-to, .slide-fade-leave {
  transform: translateX(0); /* Volta para a posição original */
  opacity: 1;
}
</style>
